/**
 * Shared Tiptap `editorProps.attributes.class` for the settlement narrative
 * editors — the per-matter editor (SettlementNarrativeSection.vue) and the
 * firm-template editor (UpdateSettlementStatementTemplatePage.vue). Both must
 * render identically, since the firm template is the starting point for every
 * matter's narrative and the two editors need to agree on what a saved value
 * looks like.
 */
const SETTLEMENT_EDITOR_CLASS_GROUPS = [
  'min-h-[140px] rounded-md border border-slate-300 bg-white px-2.5 py-2 text-[14px] leading-8 font-mono whitespace-pre-wrap focus:outline-none',
  // Real paragraphs stay compact — no default browser margin between them.
  '[&_p]:m-0',
  '[&_p:empty]:min-h-[2rem] [&_p:has(>br:only-child)]:min-h-[2rem]',
  '[&_ul]:list-disc [&_ul]:pl-6 [&_li]:my-1',
];

export default SETTLEMENT_EDITOR_CLASS_GROUPS.join(' ');
